module.exports = __webpack_public_path__ + "img/peppe.f137c013.png";